// ui-kit/sla-badge — badge presentasi SLA finance (dari SlaResult domain). Read-only, dipakai
// payments.view (verifikasi bayar/refund + penagihan) & audit.view (approval §26). Gaya = slaBadge operasional.
import { fmtDurMin, overdueDays, type SlaResult } from '@domain/sla';

// SATU atribut style saja (dua `style=` → browser buang yang kedua = warna hilang).
const PILL_BASE = 'font-size:10px;margin-left:4px;padding:1px 6px;border-radius:999px';

/** Badge SLA finance berbasis menit (dari financeSlaInfo): ⏰ Lewat (merah) / ⏳ sisa (hijau). '' bila tak berlaku (SLA off / start tak diketahui). */
export function finSlaBadge(res: SlaResult): string {
  if (!res.applies) return '';
  if (res.breached) return `<span data-slabadge="late" title="Melewati SLA" style="background:var(--dangerbg);color:var(--danger);${PILL_BASE}">⏰ Lewat ${fmtDurMin(res.overMin ?? 0)}</span>`;
  return `<span data-slabadge="ok" title="Masih dalam SLA" style="background:var(--okbg);color:var(--ok);${PILL_BASE}">⏳ ${fmtDurMin(res.leftMin ?? 0)}</span>`;
}

/** Badge penagihan (hari lewat jatuh tempo vs grace eskalasi). '' bila SLA off / belum lewat tempo.
 *  0<lewat≤grace = ⏳ tempo N hr (kuning); lewat>grace = ⏰ eskalasi N hr (merah). */
export function penagihanBadge(jatuhTempo: string | null | undefined, today: string, graceDays: number, on: boolean): string {
  if (!on || !jatuhTempo) return '';
  const od = overdueDays(jatuhTempo, today);
  if (od <= 0) return '';
  if (od > graceDays) return `<span title="Lewat batas eskalasi penagihan" data-slabadge="escalate" style="background:var(--dangerbg);color:var(--danger);font-size:10px;margin-left:4px;padding:1px 6px;border-radius:999px">⏰ eskalasi · ${od} hr</span>`;
  return `<span title="Lewat jatuh tempo (dalam grace)" data-slabadge="tempo" style="background:var(--warnbg);color:var(--warn);font-size:10px;margin-left:4px;padding:1px 6px;border-radius:999px">⏳ tempo ${od} hr</span>`;
}
